import React, { memo } from 'react'
import ControlledSwitch, { IControlledSwitchProps } from 'transfix-form/components/ControlledSwitch'
import BellOnIcon from 'transfix-icons/build/BellOnIcon'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { TEST_IDS } from '../../constants'

export interface IControlledSwitchReceiveNotificationsProps
  extends Pick<IControlledSwitchProps, 'control' | 'name'> {}

const ControlledSwitchReceiveNotifications = memo<IControlledSwitchReceiveNotificationsProps>(
  ({ control, name }) => {
    return (
      <Box display='flex' alignItems='center'>
        <BellOnIcon size='large' />
        <Box ml={2} mr={3}>
          <Typography variant='body2'>
            <strong>Receive Notifications</strong>
          </Typography>
        </Box>
        <ControlledSwitch
          control={control}
          name={name}
          SwitchProps={{ dataTest: TEST_IDS.notificationsSwitch }}
        />
      </Box>
    )
  }
)

export default ControlledSwitchReceiveNotifications
